/*
 * Copyright 2025 Intuition Robotics ltd
 */
import dayjs from "./utils/dayjs.js";

export class Days {

	public static SUNDAY = "SUNDAY";
	public static MONDAY = "MONDAY";
	public static TUESDAY = "TUESDAY";
	public static WEDNESDAY = "WEDNESDAY";
	public static THURSDAY = "THURSDAY";
	public static FRIDAY = "FRIDAY";
	public static SATURDAY = "SATURDAY";

	public static DAYS: string[] = [
		Days.SUNDAY,
		Days.MONDAY,
		Days.TUESDAY,
		Days.WEDNESDAY,
		Days.THURSDAY,
		Days.FRIDAY,
		Days.SATURDAY
	];

}

export const isToday = (target: dayjs.Dayjs) => {
	const today = dayjs().startOf('day');
	return target.isSame(today, 'd');
};

export const isYesterday = (target: dayjs.Dayjs) => {
	const yesterday = dayjs().startOf('day').subtract(1, 'day');
	return target.isSame(yesterday, 'd');
};

/**
 * @param timestamp: The timestamp to format.
 * @param format: Moment js valid format (https://momentjs.com/docs/#/displaying/format/).
 * @param relativeToToday: Whether or not to display "Yesterday" and "Today" relative to "timestamp".
 * @param omitYesterday: Whether or not to display "Yesterday", or format the timestamp using the "format" attribute.
 *                       Useful when you want to show today's time only, but yesterday's full format.
 * @param relativeFormat: The format after the word "Yesterday" or "Today".
 * @param omitToday: Return today's time omitting "Today".
 */
export const formatDateTime = (timestamp: number,
							   format: string,
							   relativeToToday: boolean = false,
							   omitToday: boolean       = false,
							   omitYesterday: boolean   = false,
							   relativeFormat: string   = ", hh:mm A") => {
	const tsMoment = dayjs(timestamp);

	if (!relativeToToday)
		return tsMoment.format(format);

	if (isToday(tsMoment))
		return omitToday ? tsMoment.format("hh:mm A") : `Today${tsMoment.format(relativeFormat)}`;

	if (isYesterday(tsMoment))
		return omitYesterday ? tsMoment.format(format) : `Yesterday${tsMoment.format(relativeFormat)}`;

	return tsMoment.format(format);
};